import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DOMAIN_CONFIG } from 'domain-config';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let cognitoConfig = DOMAIN_CONFIG[window.location.hostname]?.tenantId;
    if (cognitoConfig) {
      const clonedRequest = request.clone({
        setHeaders: {
          'X-ORG-ID': cognitoConfig
        }
      });

      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }
}
